<template>
  <div class="flex flex-wrap items-center cursor-pointer rounded">
    <div class="flex-1">
      <textarea-autosize class="text-input w-full px-2 border-0 rounded resize-none overflow-hidden"
                         :min-height="20"
                         :max-height="350"
                         :autosize="true"
                         spellcheck="false"
                         v-model="content"
      />
    </div>
  </div>
</template>

<script>
import attributeMixin from '@/mixins/attribute'
export default {
  props: ['attribute'],
  mixins: [attributeMixin],
  data () {
    return {
      content: this.attribute.value
    }
  }
}
</script>
